export default "__VITE_ASSET__p3JFnBnN__"